var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"href":"#"}},[_vm._v("Market Scan")]),_vm._v(" © "+_vm._s(new Date().getFullYear()))]),_vm._v(" "),_c('span',{staticClass:"ml-auto"})])
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Footer.vue?vue&type=template&id=59de68c8&
// module id = null
// module chunks = 